import * as Common from '@/agiles/common';
import Moment from 'moment';

export enum SupportPlanFlags {
        None = 0,
        /// <summary>
        /// あんしん導入パック
        /// </summary>
        SafeIntroductionPack = 1,
        /// <summary>
        /// あんしん導入パック追加操作指導
        /// </summary>
        SafeIntroductionAditionalOperationInstruction = 2,
        /// <summary>
        /// あんしん導入パック追加帳票設定
        /// </summary>
        SafeIntroductionAditionalReportSetting = 4,
        /// <summary>
        /// シンプル導入パック追加帳票設定
        /// </summary>
        SimpleIntroductionPack = 8,
}
export class CalcMonthlyAmountQuery extends Common.Query {
  constructor(item:Common.TenantUpdateQuery){
    super('CalcMonthlyAmountQuery', new Common.ModelBinder(Common.TenantUpdateQuery, false));
    this.licenseFlag = item.licenseFlag;
    this.licenseCount = item.licenseCount;
    this.approveLicenseCount = item.approveLicenseCount;
    this.optionFlag = item.optionFlag;
    this.storageSize = item.storageSize;
    this.scannerCount = item.scannerCount;
    this.licensePackCount = item.licensePackCount;
  }
  public licenseFlag: Number;
  public licenseCount: Number;
  public approveLicenseCount: Number;
  public optionFlag: Number;
  public storageSize: Number;
  public scannerCount : Number;
  public licensePackCount: Number;
}
export class TenantInvoiceReportQuery extends Common.ReportQuery {
  constructor() {
    super("TenantInvoiceReportQuery", null);
  }
  public closingDate: Date;
}
export class LoadTenantInvoiceReportIdQuery extends Common.Query {
  constructor() {
    super("LoadTenantInvoiceReportIdQuery", null);
  }
}

export class SupportPlanData extends Common.ObjectBase{
constructor() {
    super("SupportPlanData");
  }
  public supportPlan: Common.SupportPlanFlags;
  // サポートプランの申込履歴
  public supportPlanContracts: Array<any>;

  // あんしん導入パックの申込有無
  public contructSafeIntroduction : boolean;

  // あんしん導入パックの値引き金額
  public discountAmount : number;
  
  // ご連絡先(TEL)
  public telNo : string;
  // あんしん導入パック有効期限
  public safeIntroductionPackExpiry: Date;
  // 項目名の長さの関係から、画面に表示する有効期限を調整
  public viewSafeIntroductionPackExpiry() : string {return this.safeIntroductionPackExpiry != null ? '有効期限 ' + Moment(this.safeIntroductionPackExpiry).format('YYYY-MM-DD') : '申込なし';}

  // あんしん導入パック、各サポートプランの単価。サーバー側から取得する
  public safeIntroductionPackPrice : number;
  public safeIntroductionAditionalOperationInstructionPrice : number;
  public safeIntroductionAditionalReportSettingPrice : number;

}
export class SupportPlanLoadQuery extends Common.Query {
  constructor() {
    super("SupportPlanLoadQuery", new Common.ModelBinder(SupportPlanData, false));
  }
}
export class SupportPlanUpdateQuery extends Common.Query {
  constructor(supportPlanData:SupportPlanData) {
      super("SupportPlanUpdateQuery", null);
      this.telNo = '';
      this.applySafeIntroductionPack = false;
      this.applyAditionalOperationInstruction = 0;
      this.applyAditionalReportSetting = 0;
      this.supportPlanData = supportPlanData;
      this.applyAmount = 0;
      this.discountAmount = 0;
  }
  public supportPlanData:SupportPlanData;
  public telNo : string;
  public applySafeIntroductionPack : boolean; // あんしん導入パック申し込み
  public applyAditionalOperationInstruction : number; // 追加操作指導
  public applyAditionalReportSetting : number; // 追加帳票設定
  public applyAmount : number; // 料金
  public discountAmount : number; // 値引き金額

  public calcAmount() : number{ 
    let amount = 0;
    if(this.applySafeIntroductionPack == true) amount = this.supportPlanData.safeIntroductionPackPrice;
    amount += this.applyAditionalOperationInstruction * this.supportPlanData.safeIntroductionAditionalOperationInstructionPrice;
    amount += this.applyAditionalReportSetting * this.supportPlanData.safeIntroductionAditionalReportSettingPrice;
    this.applyAmount = amount;
    return amount;
  }
}
export class CouponCodeCheckQuery extends Common.Query {
    constructor(couponCode:string){
        super('CouponCodeCheckQuery', null);
        this.couponCode = couponCode;
    }
    public couponCode:string;
}
export class CouponExecuteQuery extends Common.Query {
    constructor(){
        super('CouponExecuteQuery', null);
    }
    public couponCode:string;
    public companyName:string;
    public pic:string;
    public telNo:string;
}
